import axios from "axios";
import {Country} from "@/modules/country/types";

export async function getRawCountries(): Promise<Country[]> {
  const response = await axios.get("https://restcountries.com/v3.1/all?fields=cca2,flags,name");
  return response.data;
}
